import { render, staticRenderFns } from "./FAQPage.vue?vue&type=template&id=50305e60&scoped=true"
import script from "./FAQPage.vue?vue&type=script&lang=js"
export * from "./FAQPage.vue?vue&type=script&lang=js"
import style0 from "./FAQPage.vue?vue&type=style&index=0&id=50305e60&prod&lang=css"
import style1 from "./FAQPage.vue?vue&type=style&index=1&id=50305e60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_8432db7643500554ffee61cb980ae8ea/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50305e60",
  null
  
)

export default component.exports